import BaseModel from "./BaseModel";
import { post } from "../common/requester";
import {action, makeObservable, observable} from "mobx";

export const AGREEMENT_CLUB1_OWNER = "CLUB1_OWNER";
export const AGREEMENT_CLUB_MEMBER = "CLUB_MEMBER";

class Agreement extends BaseModel {
  id = null;
  company_id = null;
  company_user_id = null;
  type = AGREEMENT_CLUB1_OWNER;
  title = "";
  text = "";
  version = "";
  is_active = true;
  data = {
    translations: {},
  };

  required_agreement = null;
  acceptance = null;
  accepted = false;

  // Language of the agreement actually shown to the user.
  // "default" means agreement.title/agreement.text were shown.
  language = "default";

  full_name = "";

  constructor() {
    super();

    makeObservable(this, {
      id: observable,
      company_id: observable,
      company_user_id: observable,
      type: observable,
      title: observable,
      text: observable,
      version: observable,
      is_active: observable,
      data: observable,
      required_agreement: observable,
      acceptance: observable,
      accepted: observable,
      language: observable,
      full_name: observable,

      setFromJson: action,
      getRequiredAgreement: action,
      acceptAgreement: action,
      saveAgreement: action,
    });
  }

  setFromJson(json = {}) {
    Object.keys(json || {}).forEach((key) => {
      this.setProperty(key, json[key]);
    });

    const data = this.data && typeof this.data === "object" ? this.data : {};
    const translations =
      data.translations && typeof data.translations === "object"
        ? data.translations
        : {};

    this.setProperty("data", {
      ...data,
      translations,
    });

    return this;
  }

  async getRequiredAgreement(company_user_id, type, language = null) {
    this.setProperty("company_user_id", company_user_id);

    const payload = {
      company_user_id,
      type,
    };

    if (language) {
      payload.language = language;
    }

    const ret = await post("/agreement/get_required_agreement", payload)
      .catch(err => console.error("get agreement error", err));

    if (!ret) return ret;

    this.setProperty("required_agreement", ret.agreement || null);
    this.setProperty("accepted", !!ret.accepted);
    this.setProperty("acceptance", ret.acceptance || null);

    if (ret.agreement) {
      this.setFromJson(ret.agreement);
    }

    return ret;
  }

  async acceptAgreement() {
    const ret = await post("/agreement/accept_agreement", {
      agreement_id: this.required_agreement?.id || this.id,
      company_user_id: this.company_user_id,
      full_name: this.full_name,
      language: this.language,
    }).catch(err => console.error("accept agreement error", err));

    if (!ret) return ret;

    this.setProperty("accepted", true);
    this.setProperty("acceptance", ret);

    return ret;
  }

  async saveAgreement() {
    const ret = await post("agreement/save_agreement", {
      id: this.id,
      company_id: this.company_id,
      type: this.type,
      title: this.title,
      text: this.text,
      version: this.version,
      is_active: this.is_active,
      data: this.data,
    }).catch(err => console.error("save agreement error", err));

    if (!ret) return ret;

    this.setFromJson(ret);
    return ret;
  }
}

export default Agreement;
